import { Button, ButtonDropdown } from '@amzn/awsui-components-react';

import React from 'react';
import { TableHeader } from '../commons/common-components';
import { useHistory } from 'react-router';

export interface Props {
    totalItems: number;
    selectedItems: any[];
    loading: boolean;
    exporting: boolean;
    deleting: boolean;
    onReload: () => void;
    showDeleteModal: () => void;
    exportPolls: () => void;
}

export const FanPollsTableHeader: React.FC<Props> = (props: Props) => {
    const isEmptySelection = props.selectedItems.length === 0;
    const isOnlyOneSelected = props.selectedItems.length === 1;
    const disabled = props.loading || props.exporting || props.deleting;
    const history = useHistory();

    const onItemsEdit = () => {
        history.push(`/fan-polls/${props.selectedItems[0].id}?locale=${props.selectedItems[0].locale}`);
    };

    const responsiveButtons: Button.Props[] = [
        {
            text: 'Edit',
            disabled: disabled || !isOnlyOneSelected,
            onClick: onItemsEdit,
        },
        {
            text: 'Delete',
            disabled: disabled || isEmptySelection,
            loading: props.deleting,
            onClick: props.showDeleteModal,
        },
        {
            text: 'Export as CSV',
            disabled: disabled || isEmptySelection,
            loading: props.exporting,
            onClick: props.exportPolls,
        },
    ];

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    return (
        <TableHeader
            {...props}
            title="Fan Polls"
            actionButtons={
                <div className="awsui-util-action-stripe-group">
                    <Button
                        icon="refresh"
                        disabled={disabled}
                        loading={props.loading}
                        onClick={() => props.onReload()}
                    ></Button>
                    {isMobile && (
                        <ButtonDropdown
                            items={responsiveButtons.map((b, i) => ({
                                id: `${i}`,
                                text: b.text as string,
                                disabled: b.disabled,
                            }))}
                            disabled={responsiveButtons.findIndex((b) => !b.disabled) < 0}
                            loading={responsiveButtons.findIndex((b) => b.loading) >= 0}
                        >
                            Actions
                        </ButtonDropdown>
                    )}
                    {!isMobile && responsiveButtons.map((b, i) => <Button key={i} {...b}></Button>)}
                </div>
            }
        />
    );
};
